import { API_URL } from "../../config";
import { formatDateTime } from "../../utils";

export const formatDateTimeValue = (value?: string | null) => {
  if (!value) {
    return "—";
  }

  const date = new Date(value);
  if (Number.isNaN(date.valueOf())) {
    return "—";
  }

  return formatDateTime(date);
};

export const buildPpsDownloadHref = (
  operatorId: number | null,
  identifier: string | null | undefined,
  apiUrl: string = API_URL,
) => {
  const normalizedIdentifier = identifier?.trim();

  if (!normalizedIdentifier || operatorId === null) {
    return null;
  }

  return `${apiUrl}/ops/pps/operators/${operatorId}/documents/${encodeURIComponent(
    normalizedIdentifier,
  )}`;
};

export const formatDocumentMeta = (document: OpsPpsDocument) => {
  const parts: string[] = [];
  const typeLabel = document.category || document.type;

  if (typeLabel) {
    parts.push(typeLabel);
  }

  if (document.created) {
    const formatted = formatDateTimeValue(document.created);
    if (formatted !== "—") {
      parts.push(formatted);
    }
  }

  return parts.join(" • ");
};

export type OpsPpsDownloadItem = {
  key: string;
  title: string;
  href: string | null;
  meta: string;
  typeLabel: string;
  available: boolean;
  mime: string | null;
};

export const mapDocumentsToDownloadItems = (
  documents: OpsPpsDocument[] = [],
  operatorId: number | null,
  apiUrl: string = API_URL,
): OpsPpsDownloadItem[] =>
  documents.map((document) => {
    const typeLabel = document.category || document.type || "Document";
    const href =
      document.available === false
        ? null
        : buildPpsDownloadHref(operatorId, document.identifier, apiUrl);

    return {
      key: document.identifier,
      title: document.title || document.identifier,
      href,
      meta: formatDocumentMeta(document) || typeLabel,
      typeLabel,
      available: document.available !== false,
      mime: document.mime || null,
    };
  });
